import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './global';
import { theme } from './theme';
import { useContext, useEffect, useState } from 'react';
import { AuthRedirect, StripeRedirect } from './routes';
import { AppContextProvider, AppContext } from './providers/AppContext';
import { ShopProvider } from './providers/ShopProvider';
import { AuthProvider } from './providers/AuthProvider';
import { DiscordSdkContext, DiscordSdkProvider } from './providers/DiscordSdkProvider';
import { Account } from './pages';
import { LoginModal, AppLoadingSpinner, NavBar } from './components';
import { useTokenAuth } from './hooks';
import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'
import { WagmiProvider } from 'wagmi'
import { mainnet } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { DISCORD_APP_ID } from './constants';
import { useAudio, AudioProvider } from './providers/AudioContext';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const chains = [mainnet];//IS_PRODUCTION ? [base] : [baseSepolia];
const projectId = 'b7fa64bece4cf45bfad47f013129c43c';
const metadata = {
  name: 'BaseJump',
  description: 'BaseJump',
  url: window.location.protocol + '//' + window.location.host,
  icons: ['https://images.squarespace-cdn.com/content/v1/65bb9799d452301e910b14dd/907a6c3a-828e-4e7c-ae1b-088e3bff3792/bjlogo.png?format=500w']
}

const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  coinbasePreference: 'smartWalletOnly'
})

createWeb3Modal({
  wagmiConfig: config,
  projectId,
  featuredWalletIds: ['fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa']
})

const queryClient = new QueryClient()

const StandaloneApp = () => {
  const { discordSdk, isLoading, discordToken, isDiscord } = useContext(DiscordSdkContext);
  const { accountAddress, setAccountAddress, setCurrentUserEmail, basejumpAccessToken, setBasejumpAccessToken } = useContext(AppContext);
  const { login: discordTokenLogin, basejumpToken } = useTokenAuth();
  const { isInitialized, playSFX } = useAudio();

  const [showSpinner, setShowSpinner] = useState(false);
  const [showApp, setShowApp] = useState(false);

  useEffect(() => {
    (async () => {
      if (discordToken) {
        discordTokenLogin(discordToken);
      }
    })();
  }, [discordToken]);

  useEffect(() => {
    if (isInitialized) {
      setShowSpinner(true);
      playSFX('app_loading');
      setTimeout(() => setShowApp(true), 2000);
    }
  }, [isInitialized]);

  if (!isLoading && !isDiscord && !basejumpToken) {
    return (
      <div style={{ position: 'relative', width: '100vw', height: '100vh', maxWidth: '100vw', maxHeight: '100vh'}}>
        <LoginModal/>
      </div>
    );
  }

  if (showApp && !isLoading) {
    return (
      <>
        <Account accountAddress={accountAddress} />
        <NavBar />
      </>
    );
  }

  return (
    <div className='page'>
      {showSpinner && <AppLoadingSpinner />}
    </div>
  );
};

export default function AppWrapper() {
  const router = createBrowserRouter([
    { path: "/", element: (<StandaloneApp />) },
    { path: "auth", element: (<AuthRedirect />)},
    { path: "stripe_redirect", element: (<StripeRedirect />)}
  ]);

  return (
    <ThemeProvider theme={theme}>
      <>
	<WagmiProvider config={config}>
	  <QueryClientProvider client={queryClient}>
	    <AuthProvider>
              <DiscordSdkProvider discordAppId={DISCORD_APP_ID}>
              <AppContextProvider>
                <AudioProvider>
                  <ShopProvider>
                    <GlobalStyles />
                    <RouterProvider router={router} />
                  </ShopProvider>
                </AudioProvider>
              </AppContextProvider>
              </DiscordSdkProvider>
	    </AuthProvider>
	  </QueryClientProvider>
        </WagmiProvider>
      </>
    </ThemeProvider>
  );
}
